export default {"src":"/_next/static/media/audit-readiness-and-support.453e0d41.svg","height":437,"width":331,"blurWidth":0,"blurHeight":0};